import { store } from 'redux/store';
import { useCallback, useEffect, useRef, useState } from 'react';
import { getTradingOffers } from '../redux/tradingOfferActions';

const EMPTY_FILTERS: string[] = [];

type UseGetTradingOffersProps = {
  societyId?: string;
  page?: number;
  rowsPerPage?: number;
  filters?: string[];
  refetchKey?: number;
};

export const useGetTradingOffers = ({
  societyId,
  page = 1,
  rowsPerPage = 10,
  filters = EMPTY_FILTERS,
  refetchKey = 0,
}: UseGetTradingOffersProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const filtersRef = useRef(filters);
  filtersRef.current = filters;

  const fetchTradingOffers = useCallback(
    async (controller: AbortController) => {
      if (!societyId) return;

      try {
        setIsLoading(true);

        await store.dispatch(
          getTradingOffers({
            societyId,
            params: {
              page,
              items: rowsPerPage,
              tradingOfferTypes: filtersRef.current,
            },
            signal: controller.signal,
          })
        );

        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    // refetchKey intencional para forzar refetch
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page, rowsPerPage, societyId, refetchKey]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchTradingOffers(controller);

    return () => controller.abort();
  }, [fetchTradingOffers]);

  return {
    isLoading,
    isError,
  };
};
